import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function MyArmy() {
  const [selectedBots, setSelectedBots] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('https://bot-battle-server.vercel.app/selected')
      .then(response => response.json())
      .then(data => {
        setSelectedBots(data);
      })
      .catch(error => console.error('Error fetching selected bots:', error));
  }, []);

  const handleBack = () => {
    navigate('/myteam');
  };

  const handleRemoveFromArmy = (botId) => {
    const updatedBots = selectedBots.filter(bot => bot.id !== botId);
    setSelectedBots(updatedBots);

    fetch(`https://bot-battle-server.vercel.app/selected/${botId}`, {
      method: 'DELETE',
    })
    .then(response => response.json())
    .then(() => console.log('Bot removed from army.'))
    .catch(error => console.error('Error removing bot from army:', error));
  };

  const deleteButton = (botId) => {
    const updatedBots = selectedBots.filter(bot => bot.id !== botId);
    setSelectedBots(updatedBots);

    fetch(`https://bot-battle-server.vercel.app/bots/${botId}`, {
      method: 'DELETE',
    })
    .then(response => response.json())
    .then(() => console.log('Bot removed from army.'))
    .catch(error => console.error('Error removing bot from army:', error));
    fetch(`https://bot-battle-server.vercel.app/selected/${botId}`, {
      method: 'DELETE',
    })
    .then(response => response.json())
    .then(() => console.log('Bot removed from army.'))
    .catch(error => console.error('Error removing bot from army:', error));
  }

  return (
    <div className="flex flex-col items-center mt-44 text-black">
      <h1 className="text-3xl mb-4 text-white">My Army</h1>
      <button
        onClick={handleBack}
        className="bg-blue-500 text-white p-2 rounded-lg mb-6"
      >
        Back to Collection
      </button>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        
        {selectedBots.length > 0 ? (
          selectedBots.map(bot => (
            <div key={bot.id} className="bg-green-200 p-4 rounded-lg shadow-lg text-center">
               <button
                onClick={() => deleteButton(bot.id)}
                className="bg-green-200 font-extrabold text-black text-xl hover:bg-slate-400 duration-300  p-2 rounded-lg ml-40"
              >
                X
              </button>
              <img 
                src={bot.avatar_url} 
                alt={bot.name} 
                className="w-full h-48 object-cover rounded-md mb-2" 
              />
              <h3 className="text-xl mb-2">{bot.name}</h3>
              <h3 className='text-lg mb-2'>{bot.bot_class}</h3>
              <button
                onClick={() => handleRemoveFromArmy(bot.id)}
                className="bg-red-500 text-white p-2 rounded-lg "
              >
                Remove from army
              </button>
             
            </div>
          ))
        ) : (
          <p>No bots in your army.</p>
        )}
      </div>
    </div>
  );
}

export default MyArmy;
